// extracted by mini-css-extract-plugin
module.exports = {"logo":"headerLogo_logo__p5CFI","beta":"headerLogo_beta__OXqqz"};